/**
 * Glider Handicap Data
 * DAeC/DMSt handicap index for Condor gliders
 *
 * Handicap values are used for scoring in multi-class competitions.
 * Lower handicap = slower glider, Higher handicap = faster glider
 * Reference: 100 = baseline (e.g., ASW19)
 *
 * Note: Glider names must match exactly with polar file names
 */

const POLAR_MAPPING_KEY = 'igc_polar_mappings';

/**
 * Wing Loading Data for Club Class Gliders
 * Format: { wingLoading_kgPerM2, mass_kg }
 */
export const WING_LOADING_DATA = {
  'ASW15': { wingLoading: 27.73, mass: null },
  'ASW19': { wingLoading: 29.5, mass: 324.5 },
  'ASW20': { wingLoading: 32.4, mass: 340.2 },
  'DG101G': { wingLoading: 28.6, mass: 314.6 },
  'Genesis2': { wingLoading: 29.5, mass: null },
  'Libelle': { wingLoading: 29.1, mass: 285.2 },
  'LS3a': { wingLoading: 30.8, mass: null },
  'LS4a': { wingLoading: 30.5, mass: 320.3 },
  'Pegase': { wingLoading: 31.4, mass: 329.7 },
  'StdCirrus': { wingLoading: 28.9, mass: 290.2 }
};

export const HANDICAP_DATA = {
  // Competition gliders with handicaps
  'Antares18S': 120.0,
  'Arcus': 120.0,
  'ASG29-18': 121.0,
  'ASG29Es-18': 121.0,
  'ASK21': 92.0,
  'ASW15': 97.0,
  'ASW19': 100.0,
  'ASW20': 110.0,
  'ASW28-15': 108.0,
  'Blanik': 78.0,
  'DG1000S': 106.0,
  'DG101G': 100.0,
  'DG808C-15': 113.0,
  'DG808C-18': 120.0,
  'Diana2': 116.0,
  'Discus2a': 109.0,
  'DuoDiscus': 113.0,
  'EB29R': 129.0,
  'Genesis2': 107.0,
  'GrunauBaby': 54.0,
  'JS1-18': 121.0,
  'JS1-21': 127.0,
  'JS3-15': 116.0,
  'JS3-18': 122.0,
  'K8': 76.0,
  'Ka6CR': 82.0,
  'Libelle': 98.0,
  'LS3a': 107.0,
  'LS4a': 104.0,
  'LS8neo': 109.0,
  'Pegase': 102.0,
  'PilatusB4': 88.0,
  'SG38': 22.0,
  'SGS1-26': 63.0,
  'StdCirrus': 99.0,
  'StemmeS12': 114.0,
  'SwiftS1': 77.0,
  'Ventus3-15': 116.0,
  'Ventus3-18': 122.0,

  // FXB variants (assume same handicap as base model)
  'Antares18S-FXB': 120.0,
  'Arcus-FXB': 120.0,
  'ASG29-18-FXB': 121.0,
  'ASG32Mi': 120.0,  // From .xcp
  'ASG32Mi-FXB': 120.0,
  'ASK13': 79.0,     // From .xcp
  'ASK13-FXB': 79.0,
  'ASK21-FXB': 92.0,
  'ASW15-FXB': 97.0,
  'ASW19-FXB': 100.0,
  'ASW20-FXB': 110.0,
  'Blanik-FXB': 78.0,
  'DG1000S-FXB': 106.0,
  'DG101G-FXB': 100.0,
  'Diana2-FXB': 116.0,
  'DuoDiscus-FXB': 113.0,
  'DuoDiscusFES': 113.0,  // Self-launching variant
  'DuoDiscusFES-FXB': 113.0,
  'GrunauBaby-FXB': 54.0,
  'JS1-18-FXB': 121.0,
  'JS1-21-FXB': 127.0,
  'JS3-15-FXB': 116.0,
  'JS3-18-FXB': 122.0,
  'K8-FXB': 76.0,
  'Ka6CR-FXB': 82.0,
  'Libelle-FXB': 98.0,
  'LS4a-FXB': 104.0,
  'MiniLAKFES': 103.0,  // From .xcp
  'Pegase-FXB': 102.0,
  'PilatusB4-FXB': 88.0,
  'SF28': 78.0,      // From .xcp
  'SF28-FXB': 78.0,
  'SG38-FXB': 22.0,
  'SGS1-26-FXB': 63.0,
  'StdCirrus-FXB': 99.0,
  'StemmeS12-FXB': 114.0,
  'SwiftS1-FXB': 77.0,
  'Ventus3-18-FXB': 122.0,

  // Additional gliders found in polars/xcp data
  'AS33Me-15': 116.0,  // From .xcp
  'AS33Me-18': 122.0,
  'AstirCS': 96.0,
  'AstirCS-FXB': 96.0,
  'JantarStd2': 100.0,
  'JantarStd2-FXB': 100.0,
  'JS5-24': 128.0,
  'JS5-24-FXB': 128.0,
  'Puchacz': 84.0,
  'Puchacz-FXB': 84.0,
  'Shark304ES': 119.0
};

/**
 * Glider class definitions
 * Used to categorize gliders by wingspan and competition class
 */
export const GLIDER_CLASSES = {
  // 13.5-meter Class
  '13.5-meter': [
    // Add gliders here if needed
  ],

  // Club Class
  'Club': [
    'ASW15',
    'ASW19',
    'ASW20',
    'JantarStd2',
    'Libelle',
    'LS3a',
    'LS4a',
    'Pegase',
    'DG101G',
    'StdCirrus',
    'Genesis2'
  ],

  // Standard Class (15m, non-flapped)
  'Standard': [
    'Discus2a',
    'LS8neo',
    'ASW28-15'
  ],

  // 15-meter Class (15m wingspan, with flaps)
  '15-meter': [
    'DG808C-15',
    'JS3-15',
    'Ventus3-15',
    'AS33Me-15',
    'Diana2'
  ],

  // 18-meter Class
  '18-meter': [
    'ASG29-18',
    'ASG29Es-18',
    'DG808C-18',
    'JS1-18',
    'JS3-18',
    'Ventus3-18',
    'Antares18S',
    'AS33Me-18'
  ],

  // Open Class (>18m wingspan)
  'Open': [
    'EB29R',
    'JS1-21',
    'ASG32Mi',
    'Arcus'
  ],

  // Acro Class (aerobatic)
  'Acro': [
    // Add aerobatic gliders here if needed
  ],

  // 20-meter MS Class (motor gliders)
  '20-meter MS': [
    'StemmeS12',
    'Antares18S',
    'MiniLAKFES',
    'DuoDiscusFES'
  ],

  // All Class (multi-class)
  'All': [
    // This is handled dynamically - when multiple classes detected
  ],

  // Additional classifications for reference (not Condor classes but useful)


  // Training / School
  'School': [
    'ASK13',
    'ASK21',
    'AstirCS',
    'Blanik',
    'DG1000S',
    'GrunauBaby',
    'K8',
    'Ka6CR',
    'PilatusB4',
    'Puchacz',
    'SF28',
    'SG38',
    'SGS1-26'
  ],


};

function getSavedPolarMappings() {
  if (typeof localStorage === 'undefined') {
    return {};
  }

  try {
    const parsed = JSON.parse(localStorage.getItem(POLAR_MAPPING_KEY) || '{}');
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
}

function normalizeGliderLookupKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');
}

const HANDICAP_LOOKUP_BY_NORMALIZED_KEY = (() => {
  const lookup = new Map();
  Object.keys(HANDICAP_DATA).forEach((name) => {
    lookup.set(normalizeGliderLookupKey(name), name);
  });
  return lookup;
})();

const WING_LOADING_LOOKUP_BY_NORMALIZED_KEY = (() => {
  const lookup = new Map();
  Object.keys(WING_LOADING_DATA).forEach((name) => {
    lookup.set(normalizeGliderLookupKey(name), name);
  });
  return lookup;
})();

const GLIDER_CLASS_LOOKUP_BY_NORMALIZED_KEY = (() => {
  const lookup = new Map();
  Object.values(GLIDER_CLASSES).forEach((gliders) => {
    gliders.forEach((name) => {
      lookup.set(normalizeGliderLookupKey(name), name);
    });
  });
  return lookup;
})();

function resolveCanonicalGliderName(gliderName) {
  if (!gliderName) {
    return null;
  }

  const rawName = String(gliderName).trim();
  if (!rawName) {
    return null;
  }

  const savedMappings = getSavedPolarMappings();
  const mappedName = savedMappings[rawName] || rawName;
  const candidates = [
    mappedName,
    rawName,
    mappedName.replace(/-FXB$/i, ''),
    rawName.replace(/-FXB$/i, '')
  ].filter(Boolean);

  for (const candidate of candidates) {
    if (HANDICAP_DATA[candidate] || WING_LOADING_DATA[candidate]) {
      return candidate;
    }
  }

  for (const candidate of candidates) {
    const normalized = normalizeGliderLookupKey(candidate);
    const matched =
      HANDICAP_LOOKUP_BY_NORMALIZED_KEY.get(normalized) ||
      WING_LOADING_LOOKUP_BY_NORMALIZED_KEY.get(normalized) ||
      GLIDER_CLASS_LOOKUP_BY_NORMALIZED_KEY.get(normalized);
    if (matched) {
      return matched;
    }
  }

  return mappedName;
}

function getHandicapOverride(gliderName, taskOrOverrides = null) {
  if (!gliderName || !taskOrOverrides || typeof taskOrOverrides !== 'object') {
    return null;
  }

  const overrideSource =
    taskOrOverrides.handicapOverrides &&
    typeof taskOrOverrides.handicapOverrides === 'object' &&
    !Array.isArray(taskOrOverrides.handicapOverrides)
      ? taskOrOverrides.handicapOverrides
      : taskOrOverrides;

  const rawName = String(gliderName).trim();
  if (!rawName) {
    return null;
  }

  const savedMappings = getSavedPolarMappings();
  const mappedName = savedMappings[rawName] || rawName;
  const normalizedCandidates = new Set(
    [rawName, mappedName, rawName.replace(/-FXB$/i, ''), mappedName.replace(/-FXB$/i, '')]
      .filter(Boolean)
      .map(normalizeGliderLookupKey)
  );

  const directCandidates = [rawName, mappedName, rawName.replace(/-FXB$/i, ''), mappedName.replace(/-FXB$/i, '')]
    .filter(Boolean);

  for (const candidate of directCandidates) {
    const override = Number(overrideSource[candidate]);
    if (Number.isFinite(override) && override > 0) {
      return override;
    }
  }

  for (const [key, value] of Object.entries(overrideSource)) {
    if (!normalizedCandidates.has(normalizeGliderLookupKey(key))) {
      continue;
    }

    const override = Number(value);
    if (Number.isFinite(override) && override > 0) {
      return override;
    }
  }

  return null;
}

/**
 * Get handicap for a glider
 * @param {string} gliderName - Name of the glider (must match polar file name)
 * @param {object|null} taskOrOverrides - Optional task object or plain override map
 * @returns {number|null} Handicap value or null if not found
 */
export function getHandicap(gliderName, taskOrOverrides = null) {
  const override = getHandicapOverride(gliderName, taskOrOverrides);
  if (Number.isFinite(override) && override > 0) {
    return override;
  }

  const resolvedName = resolveCanonicalGliderName(gliderName);
  return HANDICAP_DATA[resolvedName] || null;
}

/**
 * Get all classes a glider belongs to
 * @param {string} gliderName - Name of the glider
 * @returns {Array<string>} Array of class names
 */
export function getGliderClasses(gliderName) {
  const classes = [];
  const resolvedName = resolveCanonicalGliderName(gliderName);
  const candidates = new Set(
    [resolvedName, gliderName]
      .filter(Boolean)
      .flatMap((name) => [name, String(name).replace(/-FXB$/i, '')])
  );

  for (const [className, gliders] of Object.entries(GLIDER_CLASSES)) {
    if ([...candidates].some((candidate) => gliders.includes(candidate))) {
      classes.push(className);
    }
  }

  return classes;
}

/**
 * Get primary class for a glider (first/main class)
 * @param {string} gliderName - Name of the glider
 * @returns {string|null} Primary class name or null
 */
export function getPrimaryClass(gliderName) {
  const classes = getGliderClasses(gliderName);
  return classes.length > 0 ? classes[0] : null;
}

/**
 * Check if glider is allowed (has handicap data)
 * @param {string} gliderName - Name of the glider
 * @returns {boolean} True if glider is in the allowed list
 */
export function isGliderAllowed(gliderName) {
  const resolvedName = resolveCanonicalGliderName(gliderName);
  return resolvedName in HANDICAP_DATA;
}

/**
 * Get default wing loading for a glider
 * @param {string} gliderName - Name of the glider
 * @returns {number|null} Wing loading in kg/m² or null if not found
 */
export function getDefaultWingLoading(gliderName) {
  const resolvedName = resolveCanonicalGliderName(gliderName);
  const baseName = String(resolvedName || gliderName || '').replace(/-FXB$/i, '');
  return WING_LOADING_DATA[baseName]?.wingLoading || WING_LOADING_DATA[resolvedName]?.wingLoading || null;
}

/**
 * Get all gliders in a specific class
 * @param {string} className - Class name (e.g., '15M', 'OPEN', 'CLUB')
 * @returns {Array<string>} Array of glider names
 */
export function getGlidersInClass(className) {
  return GLIDER_CLASSES[className] || [];
}

/**
 * Calculate handicapped score
 * @param {number} rawScore - Raw score/points
 * @param {string} gliderName - Name of the glider
 * @returns {number} Handicapped score (rawScore * 100 / handicap)
 */
export function calculateHandicappedScore(rawScore, gliderName, taskOrOverrides = null) {
  const handicap = getHandicap(gliderName, taskOrOverrides);
  if (!handicap || handicap === 0) {
    return rawScore;
  }
  return (rawScore * 100) / handicap;
}
